import { Controller } from "@hotwired/stimulus"

declare global {
  interface Window {
    Intercom?: (command: string, ...args: unknown[]) => void
  }
}

export default class extends Controller {
  showMessages(event: Event): void {
    event.preventDefault()

    if (window.Intercom) {
      window.Intercom("showSpace", "messages")
    }
  }

  showHelp(event: Event): void {
    event.preventDefault()

    if (window.Intercom) {
      window.Intercom("showSpace", "help")
    }
  }
}
